import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { getAssetPath } from "../../../../../../lib/assetPath";

type MainFragranceCardProps = {
    topFetiche: ProfilerProduct | null;
  };
  
  export const MainFragranceCard = ({ topFetiche }: MainFragranceCardProps) => {
    const imagePath = `/beauty-profiler/main-fragrances/${topFetiche?.id}.avif`;
    return (
      <div className="flex flex-col mt-20 rounded-t-full bg-white items-center relative z-1">
        <img
          src={getAssetPath(imagePath)}
          alt={imagePath}
          className="w-full p-1 rounded-t-full"
        />
        <div className="flex flex-col items-center gap-2 p-4">
          <p className="font-minion text-[14px] text-[#CE0A2C] leading-[150%] font-normal">
            Your favorite fragrance is
          </p>
          <h2 className="text-[#050505] text-center font-minion text-[20px] font-normal">
            {topFetiche?.label}
          </h2>
        </div>
      </div>
    );
  };